import React, { useState, useEffect, useRef } from "react";
import {
  fetchUserServices,
  getUserPracticeById,
  updateAppointment,
  calculateAppointment,
  fetchallUsersByPractices,
  getAppointmentsByPracticeIds,
  getAccountByPatientId,
  deleteAppointment,
  deleteAppointmentSeries,
} from "../../api";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Alert from "react-bootstrap/Alert";
import Dropdown from "react-bootstrap/Dropdown";
import Table from "react-bootstrap/Table";
import { FaCheck, FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AddPatientSteps } from "../PatientsAccounts/AddPatientInfo";
import AppToast from "../Toasts/AppToast";
import { useToast } from "../Toasts/useToast";
import "./EditAppointments.css";
import { createIntakeSession, linkIntakeToAppointment, getIntakeSessionForStaff, getIntakeEnabledForPractice } from "../../intakeApi";

export function EditAppointmentModal({
  show,
  onHide,
  event,
  resources,
  addNotification,
  practiceIds,
  setEvents,
}) {
  const [services, setServices] = useState([]);
  const [practices, setPractices] = useState([]);
  const [alertMessage, setAlertMessage] = useState(false);
  const [alertSuggestions, setAlertSuggestions] = useState([]);
  const [selectedSuggestion, setSelectedSuggestion] = useState(null);
  const { toast, showToast, hideToast } = useToast();
  const [errors, setErrors] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [resourceList, setResourceList] = useState([]);
  const [selectedPracticeId, setSelectedPracticeId] = useState("");
  const [selectedResourceId, setSelectedResourceId] = useState("");
  const [filteredResources, setFilteredResources] = useState([]);
  const [closeAlert, setCloseAlert] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [suggestedStart, setSuggestedStart] = useState("");
  const [alertText, setAlertText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [account, setAccount] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [refreshTick, setRefreshTick] = useState(0);
  const navigate = useNavigate();
  const [selectedLocationIdx, setSelectedLocationIdx] = useState(0);
  const [locationsForPractice, setLocationsForPractice] = useState([]);
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [deleteSeriesAlert, setDeleteSeriesAlert] = useState(false);
  const [showDeleteSubmenu, setShowDeleteSubmenu] = useState(false);
  const [showStatusSubmenu, setShowStatusSubmenu] = useState(false);
  const [actionsOpen, setActionsOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [intakeSession, setIntakeSession] = useState(null);
  const [sendIntakeEmail, setSendIntakeEmail] = useState(false);
  const [sendIntakeSMS, setSendIntakeSMS] = useState(false);
  const [intakeSending, setIntakeSending] = useState(false);
  const [intakeEnabled, setIntakeEnabled] = useState(false);
  const [intakeOutcomeOpen, setIntakeOutcomeOpen] = useState(false);
  const [intakeConsentOpen, setIntakeConsentOpen] = useState(false);
  const [intakeDataOpen, setIntakeDataOpen] = useState(false);
  const [intakeHistoryOpen, setIntakeHistoryOpen] = useState(false);

  // 🔧 FIX: Separate refs for different initialization stages
  const isInitializedRef = useRef(false);
  const hasCalculatedEndRef = useRef(false);
  const locationInitializedRef = useRef(false);

  const [appointment, setAppointment] = useState({
    title: "",
    patientFirstName: "",
    patientLastName: "",
    start: "",
    end: "",
    patientId: "",
    serviceId: "",
    reminderInterval: [],
    reminderType: [],
    notes: "",
    resourceName: "",
    resourceId: "",
    practiceId: "",
    status: "",
    eventColor: "",
    patientEmail: "",
    patientPhone: "",
    borderColor: "",
    backgroundColor: "",
    appointmentCreatedBy: "",
    appointmentCreatedDate: "",
    appointmentConfirmationEmail: "",
    confirmEmail: true,
    recurringData: {},
  });

  // helpers
  const toNaiveLocal = (v) => {
    if (typeof v === "string" && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(v))
      return v;
    const d = v instanceof Date ? v : new Date(v);
    if (isNaN(d)) return "";
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
      d.getDate()
    )}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  };

  const openAddPatientInfo = () => {
    onHide?.();
    setTimeout(() => {
      setModalData({
        patientFirstName: appointment.patientFirstName || "",
        patientLastName: appointment.patientLastName || "",
        patientEmail: appointment.patientEmail || "",
        patientPhone: appointment.patientPhone || "",
        appointmentId: appointment.id || event?.id || "",
      });
      setModalShow(true);
    }, 0);
  };

  const getExt = (e) => e?._def?.extendedProps ?? e?.extendedProps ?? {};
  const toId = (x) =>
    typeof x === "string" ? x : x?.id || x?._id || x?.userId || "";
  const isPractitioner = (u) =>
    Array.isArray(u.role)
      ? u.role.includes("Practitioner")
      : String(u.role || "").includes("Practitioner");

  const buildFallbackLocations = (p) => {
    if (Array.isArray(p?.locations) && p.locations.length) return p.locations;
    return [
      {
        name: p?.primaryLocationName || "Main Location",
        address1: p?.practiceAddress || "",
        address2: p?.practiceAddress2 || "",
        city: p?.practiceCity || "",
        province: p?.practiceProvince || "",
        postalCode: p?.practicePostalCode || "",
      },
    ];
  };

  const compactAddress = (loc = {}) =>
    [
      loc.address1,
      loc.address2,
      [loc.city, loc.province].filter(Boolean).join(", "),
      loc.postalCode,
    ]
      .filter(Boolean)
      .join(" | ");

  const toMinuteString = (v) => {
    if (!v) return "";
    if (typeof v === "string") {
      const m = v.match(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2})(?::\d{2})?$/);
      if (m) return m[1];
      const d2 = new Date(v);
      if (!isNaN(d2)) return toMinuteStringFromDate(d2);
      return "";
    }
    if (v instanceof Date && !isNaN(v)) return toMinuteStringFromDate(v);
    const d = new Date(v);
    return isNaN(d) ? "" : toMinuteStringFromDate(d);
  };

  const toMinuteStringFromDate = (d) => {
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
      d.getDate()
    )}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
  };

  const pickStartStr = (evt) => {
    const ext = getExt(evt);
    return toMinuteString(ext.start ?? evt.startStr ?? evt.start);
  };

  const pickEndStr = (evt) => {
    const ext = getExt(evt);
    const raw = ext.end ?? evt.endStr ?? evt.end;
    return raw ? toMinuteString(raw) : "";
  };

  // ============ 🔧 FIX: Single initialization effect with proper guards ============
  useEffect(() => {
    if (!show || !event) {
      // Reset all refs when modal closes
      isInitializedRef.current = false;
      hasCalculatedEndRef.current = false;
      locationInitializedRef.current = false;
      setIsEditMode(false);
      setDeleteAlert(false);
      setShowStatusSubmenu(false);
      setActionsOpen(false);
      setIntakeSession(null);
      setSendIntakeEmail(false);
      setSendIntakeSMS(false);
      return;
    }

    // Only initialize once per modal open
    if (isInitializedRef.current) return;

    const ext = getExt(event);
    const practiceId = ext.practiceId || event.practiceId || "";
    const resourceId =
      ext.resourceId ||
      event.resourceId ||
      (Array.isArray(event.resourceIds) ? event.resourceIds[0] : "");

    const startStr = pickStartStr(event);
    const endStr = pickEndStr(event);

    // 🔧 FIX: Preserve ALL location data from the event
    const eventLocation = ext.location ?? event.location ?? null;
    const eventLocationName = ext.locationName ?? event.locationName ?? "";
    const eventLocationAddress =
      ext.locationAddress ?? event.locationAddress ?? "";
    const eventLocationIdx =
      typeof ext.locationIdx === "number" ? ext.locationIdx : null;
    console.log("event", event);
    setAppointment({
      id: event.id || "",
      title: event.title || "",
      patientFirstName: event.patientFirstName || "",
      patientLastName: event.patientLastName || "",
      patientEmail: event.patientEmail || "",
      patientPhone: event.patientPhone || "",
      start: startStr,
      end: endStr,
      serviceId: event.serviceId || "",
      notes: event.notes || "",
      resourceId: resourceId,
      resourceName: ext.resourceName || event.resourceName || "",
      practiceId: practiceId,
      patientId: event.patientId || "",
      appointmentConfirmationEmail: false,
      confirmEmail: false,
      status: event.status || "Pending",
      backgroundColor:
        event.status === "Scheduling" ? "#D3D3D3" : event.color || "#0F3490",
      // 🔧 CRITICAL: Preserve location data exactly as it comes from backend
      location: eventLocation,
      locationName: eventLocationName,
      locationAddress: eventLocationAddress,
      locationIdx: eventLocationIdx,
      isInvoiced: event.isInvoiced || false,
      isInvoiceEmailed: event.isInvoiceEmailed || false,
      isPaid: event.isPaid || false,
      isNotesDone: event.isNotesDone || false,
      isRecurring: event.isRecurring || ext.isRecurring || false,
      recurringID: event.recurringID || ext.recurringID || "",
    });

    setSelectedResourceId(resourceId || "");
    setSelectedStatus(event.status || "Pending");

    // 🔧 Mark as initialized and that we already have an end time
    isInitializedRef.current = true;
    if (endStr) {
      hasCalculatedEndRef.current = true;
    }
  }, [show, event]);

  // Load linked intake session when modal opens (if one was sent for this appointment)
  useEffect(() => {
    if (!show || !event) return;
    const tokenId = event.intakeSessionTokenId;
    if (!tokenId) { setIntakeSession(null); return; }
    getIntakeSessionForStaff(tokenId)
      .then((data) => setIntakeSession(data))
      .catch(() => setIntakeSession(null));
  }, [show, event]);

  // Check if intake is enabled for this practice (T&C configured)
  useEffect(() => {
    const practiceId = event?.practiceId;
    if (!show || !practiceId) { setIntakeEnabled(false); return; }
    getIntakeEnabledForPractice(practiceId).then(setIntakeEnabled);
  }, [show, event?.practiceId]);

  // ============ 🔧 FIX: Fetch lists only once after initialization ============
  useEffect(() => {
    if (!show || !isInitializedRef.current) return;

    const practiceId = appointment.practiceId;
    const resourceId = appointment.resourceId;

    // Only fetch once per practice/resource combination
    let isMounted = true;

    (async () => {
      try {
        if (practiceId) {
          const users = await fetchallUsersByPractices([practiceId]);
          if (!isMounted) return;

          const normalized = (users || []).map((u) => ({
            ...u,
            id: u.id || u._id,
          }));
          const practitioners = normalized.filter(isPractitioner);
          setResourceList(practitioners);
          setFilteredResources(practitioners); // 🔧 Set both lists
        }

        if (resourceId) {
          const servicesList = await fetchUserServices(resourceId);
          if (!isMounted) return;
          setServices(servicesList || []);
        }

        if (resourceId) {
          const practiceList = await getUserPracticeById(resourceId);
          if (!isMounted) return;
          setPractices(practiceList || []);
        }

        if (appointment.patientId) {
          const account = await getAccountByPatientId(appointment.patientId);
          setAccount(account);
        }
      } catch (err) {
        console.error("❌ fetch lists error:", err);
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [show, isInitializedRef.current]); // 🔧 Only depends on initialization

  // ============ 🔧 REPLACE the location initialization useEffect with this ============
  useEffect(() => {
    if (!show || !isInitializedRef.current || locationInitializedRef.current)
      return;
    if (!practices.length || !appointment.practiceId) return;

    const p = practices.find(
      (pr) => pr.practiceNumber === appointment.practiceId
    );
    if (!p) return;

    const locs = buildFallbackLocations(p);
    setLocationsForPractice(locs);

    console.log("📍 Location Init:", {
      appointmentLocationName: appointment.location?.name,
      availableLocations: locs.map((l) => l.name),
      currentSelectedIdx: selectedLocationIdx,
    });
    console.log("event", event);

    // 🔧 KEY FIX: Find the index that matches the appointment's location
    // This is EXACTLY how resource/therapist works
    let matchedIdx = 0; // Default fallback

    if (appointment.locationName) {
      const found = locs.findIndex(
        (l) =>
          (l.name || "").trim().toLowerCase() ===
          appointment.locationName.trim().toLowerCase()
      );

      if (found >= 0) {
        matchedIdx = found;
        console.log("✅ Found matching location at index:", found);
      } else {
        console.warn(
          "⚠️ Location from backend not found in practice locations, using default"
        );
      }
    }

    // 🔧 CRITICAL: Set the index BUT DON'T modify appointment data
    // The appointment already has the correct location data from initial load
    setSelectedLocationIdx(matchedIdx);

    locationInitializedRef.current = true;
  }, [
    show,
    practices,
    appointment.practiceId,
    appointment.locationName,
    isInitializedRef.current,
  ]);


  // ============ 🔧 FIX: Recalculate end when user manually changes start/service/resource ============
  useEffect(() => {
    if (!show || !isInitializedRef.current) return;
    if (hasCalculatedEndRef.current) return; // 🔧 Don't recalculate if we already have end time (initial load)
    if (appointment.status === "Scheduling") return;
    if (!appointment.start || !appointment.serviceId || !appointment.resourceId)
      return;

    const svc = services.find((s) => s._id === appointment.serviceId);
    if (!svc?.servicesDuration) return;

    (async () => {
      try {
        const result = await calculateAppointment({
          appointment: {
            start: appointment.start,
            resourceId: appointment.resourceId,
            practitionerName: appointment.resourceName || "",
            appointmentId: appointment.id, // 🔧 ADD THIS
          },
          selectedService: {
            servicesDuration: svc.servicesDuration,
            serviceId: svc._id,
          },
        });

        if (result?.endTime) {
          const nextEnd =
            typeof result.endTime === "string"
              ? result.endTime
              : toNaiveLocal(result.endTime);

          setAppointment((prev) => ({ ...prev, end: nextEnd }));
          hasCalculatedEndRef.current = true; // Mark as calculated
        } else if (
          Array.isArray(result?.suggestions) &&
          result.suggestions.length
        ) {
          setAppointment((p) => ({ ...p, end: "" }));
          setAlertMessage(true);
          setAlertText(
            "The selected time is unavailable. Please choose one of the suggested start times below."
          );
          setAlertSuggestions(result.suggestions);
          setSuggestedStart(result.suggestions[0].suggestedStartTime);
        }
      } catch (e) {
        console.error("calc end error:", e);
      }
    })();
  }, [
    show,
    appointment.start,
    appointment.serviceId,
    appointment.resourceId,
    services,
  ]); // 🔧 React to changes BUT guard with hasCalculatedEndRef

  // ------------- handlers --------------

  const handleStartTimeChange = (e) => {
    setAppointment((prev) => ({ ...prev, start: e.target.value }));
    hasCalculatedEndRef.current = false; // Allow recalculation when user changes start
  };

  const handleEndTimeChange = (e) => {
    setAppointment((prevState) => ({ ...prevState, end: e.target.value }));
  };

  const handleChangeAppointment = (e) => {
    const { name, value } = e.target;
    setAppointment((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleServiceChange = (e) => {
    const selectedServiceId = e.target.value;
    setAppointment((prev) => ({ ...prev, serviceId: selectedServiceId }));
    hasCalculatedEndRef.current = false; // Allow recalculation when user changes service

    const svc = services.find((s) => s._id === selectedServiceId);
    if (svc?.servicesUser?.length) {
      const allowed = new Set(svc.servicesUser.map(toId));
      setFilteredResources(resourceList.filter((r) => allowed.has(toId(r))));
    } else {
      setFilteredResources(resourceList);
    }
  };

  function validateForm() {
    let newErrors = {};
    if (!appointment.title || appointment.title.trim() === "") {
      newErrors.title = "Title is required.";
    }
    if (!appointment.start) newErrors.start = "Start time is required.";
    if (!appointment.end) newErrors.end = "End time is required.";
    if (
      appointment.start &&
      appointment.end &&
      appointment.start >= appointment.end
    ) {
      newErrors.end = "End time must be after the start time.";
    }
    if (!appointment.resourceId) {
      newErrors.resourceId = "Therapist selection is required.";
    }
    if (appointment.status !== "Scheduling") {
      if (!appointment.serviceId)
        newErrors.serviceId = "Service selection is required.";
      if (!appointment.practiceId)
        newErrors.practiceId = "Practice selection is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }

  async function handleSaveAppointment() {
    if (!appointment.start || !appointment.end || (appointment.status !== "Scheduling" && !appointment.serviceId)) {
      setErrorMessage("Start time, end time, and service are required.");
      return;
    }
    setErrorMessage("");
    if (!validateForm()) {
      console.error("Validation failed!");
      return;
    }

    const updatedAppointment = {
      ...appointment,
      recurringData: "",
      isRecurring: false,
      recurringID: "",
    };

    setIsLoading(true);
    try {
      // Send intake form if either checkbox is checked
      if ((sendIntakeEmail && appointment.patientEmail) || (sendIntakeSMS && appointment.patientPhone)) {
        setIntakeSending(true);
        try {
          const result = await createIntakeSession({
            practiceNumber: appointment.practiceId,
            patientName: [appointment.patientFirstName, appointment.patientLastName].filter(Boolean).join(" "),
            deliveryEmail: sendIntakeEmail ? appointment.patientEmail : null,
            deliverySMS: sendIntakeSMS ? appointment.patientPhone : null,
          });
          if (result.tokenId) {
            await linkIntakeToAppointment(result.tokenId, appointment.id);
            setIntakeSession({ ...result, status: "CREATED" });
          }
        } catch {
          // Non-fatal
        } finally {
          setIntakeSending(false);
          setSendIntakeEmail(false);
          setSendIntakeSMS(false);
        }
      }

      await updateAppointment(appointment.id, updatedAppointment);
      const updatedAppointments = await getAppointmentsByPracticeIds(
        practiceIds
      );
      console.log("✅ Updated Appointments Fetched:", updatedAppointments);

      const formattedEvents = updatedAppointments.map((evt) => {
        const id = evt.id || evt._id;

        // normalize location object for convenience
        const location = evt.location || {
          name: evt.locationName || "",
          address1: evt.locationAddress || "",
          address2: evt.locationAddress2 || "",
          city: evt.locationCity || "",
          province: evt.locationProvince || "",
          postalCode: evt.locationPostalCode || "",
        };

        return {
          // FC core fields
          id,
          title: evt.title,
          start: evt.start, // keep your DB "YYYY-MM-DDTHH:mm" strings
          end: evt.end,
          status: evt.status || "",

          // IMPORTANT for resource views:
          resourceId: evt.resourceId || undefined,
          resourceIds: evt.resourceId ? [evt.resourceId] : undefined,

          // optional visuals if you use them
          backgroundColor: evt.backgroundColor,
          borderColor: evt.borderColor,

          // everything else here
          extendedProps: {
            ...evt,
            startRaw: evt.start,
            endRaw: evt.end,
            location,
            patientEmail: evt.patientEmail,
            patientPhone: evt.patientPhone,
          },
        };
      });

      setEvents(formattedEvents);
      showToast("success", "Appointment successfully updated!");
      onHide();

      if (
        appointment.appointmentConfirmationEmail &&
        appointment.patientEmail
      ) {
        addNotification({
          message: `Updated confirmation email sent to ${appointment.patientEmail}`,
          timestamp: Date.now(),
          type: "email",
        });
      }
    } catch (error) {
      console.error("Error updating appointment:", error);
    } finally {
      setIsLoading(false);
    }
  }

  function handleNavToInvoice() {
    const appt = appointment;
    navigate(`/invoices/1/${account._id}`, {
      state: {
        servicesId: appt?.serviceId,
        appointmentId: appt?._id || appt?.id,
        appointmentStart: appt?.start || appt?.startTime || null,
        appointmentEnd: appt?.end || appt?.endTime || null,
        patientId: appt?.patientId,
        practiceId: appt?.practiceId || null,
        practitionerId:
          appt?.practitionerId || appt?.userId || appt?.resourceId || null,
      },
    });
  }

  function handleClose() {
    setAppointment({});
    onHide();
    setSelectedPracticeId("");
    setSelectedSuggestion(null);
    setAlertMessage(false);
    setIsEditMode(false);
    setDeleteAlert(false);
    setShowStatusSubmenu(false);
    setActionsOpen(false);
  }

  const handleCancelNo = () => {
    setCloseAlert(false);
  };

  const handleCancelYes = () => {
    setCloseAlert(false);
    setAppointment({});
    onHide();
    setSelectedPracticeId("");
    setSelectedSuggestion(null);
    setAlertMessage(false);
    setIsEditMode(false);
    setDeleteAlert(false);
    setShowStatusSubmenu(false);
    setActionsOpen(false);
  };

  const handleStatusUpdate = async (newStatus) => {
    setIsUpdatingStatus(true);
    try {
      await updateAppointment(appointment.id, {
        ...appointment,
        status: newStatus,
        confirmEmail: false,
      });
      const updatedAppointments = await getAppointmentsByPracticeIds(
        practiceIds
      );

      const formattedEvents = updatedAppointments.map((evt) => ({
        ...evt,
        extendedProps: {
          ...evt,
          patientEmail: evt.patientEmail,
        },
      }));

      setEvents(formattedEvents);
      setSelectedStatus(newStatus);
      setAppointment((prev) => ({ ...prev, status: newStatus }));
      showToast("success", "The status has been updated!");
      setTimeout(() => {
        setIsUpdatingStatus(false);
      }, 2000);
    } catch (error) {
      console.error("Error updating status:", error);
      setIsUpdatingStatus(false);
    }
  };

  const handleNavToAppointment = () => {
    if (appointment.status === "New Patient") {
      return navigate(`/newpatients/session/${appointment.id}`);
    } else {
      if (appointment.status === "Completed") {
        return navigate(`/patients/appointment/${appointment.patientId}/1`, { state: { collapsed: true } });
      } else {
        return navigate(
          `/patients/appointment/${appointment.patientId}/${appointment.id}`,
          { state: { collapsed: true } }
        );
      }
    }
  };

  return (
    <div>
      <Modal show={show} onHide={handleClose} size="lg" centered>
       <Modal.Header closeButton>
  <div className="d-flex align-items-center justify-content-between w-100">
    {/* --- Left side: title + status icon + tracking icons --- */}
    <div className="d-flex align-items-center gap-2">
      <Modal.Title className="text-primary">
        {appointment.title || "Edit Appointment"}
        {account?.accountIODFund ? (
          <sup>
            <span className="badge bg-warning text-dark ms-2" title="IOD" style={{ fontSize: "0.55rem", verticalAlign: "super" }}>
              I
            </span>
          </sup>
        ) : account?.accountMedicalAid ? (
          <sup>
            <span className="badge bg-primary ms-2" title="Medical Aid" style={{ fontSize: "0.55rem", verticalAlign: "super" }}>
              M
            </span>
          </sup>
        ) : account?._id ? (
          <sup>
            <span className="badge bg-secondary ms-2" title="Private" style={{ fontSize: "0.55rem", verticalAlign: "super" }}>
              P
            </span>
          </sup>
        ) : null}
      </Modal.Title>
      {(() => {
        const statusMap = {
          "Pending": { icon: "fa-circle-question", color: "text-muted" },
          "New Patient": { icon: "fa-triangle-exclamation", color: "text-danger" },
          "Confirmed": { icon: "fa-calendar-check", color: "text-success" },
          "Arrived": { icon: "fa-location-dot", color: "text-secondary" },
          "In Session": { icon: "fa-spinner", color: "text-info" },
          "Completed": { icon: "fa-circle-check", color: "text-primary" },
          "No Show": { icon: "fa-ban", color: "text-danger" },
          "Cancelled": { icon: "fa-circle-xmark", color: "text-cancelled" },
          "Scheduling": { icon: "fa-clock", color: "text-muted" },
        };
        const s = statusMap[appointment.status];
        return s ? (
          <i
            className={`fa-solid ${s.icon} ${s.color} ms-2 mt-1`}
            title={appointment.status}
            style={{ fontSize: "1rem" }}
          ></i>
        ) : null;
      })()}

      <i
        className="fa-solid fa-rotate"
        title={appointment?.isRecurring ? "Recurring appointment" : "Not recurring"}
        style={{
          fontSize: "0.9rem",
          color: appointment?.isRecurring ? "#0f3490" : "rgb(207, 226, 255)",
        }}
      ></i>

      <span style={{ borderLeft: "1px solid #dee2e6", height: "1.2rem", margin: "0 4px" }}></span>

      <i
        className="fa-light fa-file-circle-info mt-1"
        title={intakeSession ? "Intake form sent" : "No intake form sent"}
        style={{
          fontSize: "1rem",
          color: intakeSession ? "#0f3490" : "rgb(207, 226, 255)",
        }}
      ></i>
      <i
        className="fa-solid fa-clipboard mt-1"
        title={appointment?.isNotesDone ? "Notes completed" : "Notes not done"}
        style={{
          fontSize: "1rem",
          color: appointment?.isNotesDone ? "#0f3490" : "rgb(207, 226, 255)",
        }}
      ></i>
      <i
        className="fa-solid fa-file-invoice mt-1"
        title={appointment?.isInvoiced ? "Invoiced" : "Not invoiced"}
        style={{
          fontSize: "1rem",
          color: appointment?.isInvoiced ? "#0f3490" : "rgb(207, 226, 255)",
        }}
      ></i>
      <i
        className="fa-solid fa-envelope mt-1"
        title={appointment?.isInvoiceEmailed ? "Invoice emailed" : "Invoice not emailed"}
        style={{
          fontSize: "1rem",
          color: appointment?.isInvoiceEmailed ? "#0f3490" : "rgb(207, 226, 255)",
        }}
      ></i>
      <i
        className="fa-solid fa-credit-card mt-1"
        title={appointment?.isPaid ? "Paid" : "Not paid"}
        style={{
          fontSize: "1rem",
          color: appointment?.isPaid ? "#0f3490" : "rgb(207, 226, 255)",
        }}
      ></i>
    </div>

    {/* --- Right side: Actions dropdown --- */}
    <div className="me-4">
      <Dropdown
        show={actionsOpen}
        onToggle={(isOpen) => {
          setActionsOpen(isOpen);
          if (!isOpen) { setShowStatusSubmenu(false); setShowDeleteSubmenu(false); }
        }}
      >
        <Dropdown.Toggle variant="primary" size="sm" id="actions-dropdown">
          <i className="fa-solid fa-gears" />
          <span className="d-none d-md-inline ms-1">Actions</span>
        </Dropdown.Toggle>
        <Dropdown.Menu align="end" className="shadow-sm">
          <Dropdown.Item onClick={() => { setIsEditMode(true); setActionsOpen(false); }}>
            <i className="fa fa-edit me-2"></i> Edit
          </Dropdown.Item>
          <Dropdown.Item onClick={(e) => { e.stopPropagation(); setShowStatusSubmenu(!showStatusSubmenu); }}>
            <i className="fa fa-refresh me-2"></i> Update Status
            <i className={`fa-solid fa-chevron-${showStatusSubmenu ? "up" : "down"} ms-2`} style={{ fontSize: "0.7rem" }}></i>
          </Dropdown.Item>
          {showStatusSubmenu && [
            { label: "Pending", icon: "fa-circle-question", color: "text-muted" },
            { label: "New Patient", icon: "fa-triangle-exclamation", color: "text-danger" },
            { label: "Confirmed", icon: "fa-calendar-check", color: "text-success" },
            { label: "Arrived", icon: "fa-location-dot", color: "text-secondary" },
            { label: "In Session", icon: "fa-spinner", color: "text-info" },
            { label: "Completed", icon: "fa-circle-check", color: "text-primary" },
            { label: "No Show", icon: "fa-ban", color: "text-danger" },
            { label: "Cancelled", icon: "fa-circle-xmark", color: "text-danger" },
            { label: "Scheduling", icon: "fa-clock", color: "text-muted" },
          ].map(({ label, icon, color }) => {
            const isCurrent = appointment.status === label;
            const isDisabled =
              label === "Scheduling" ||
              appointment.status === "Completed" ||
              appointment.status === "Scheduling" ||
              (appointment.status === "New Patient" &&
                label !== "New Patient" &&
                label !== "Cancelled" &&
                label !== "No Show") ||
              (appointment.status === "Cancelled" && label !== "Cancelled");
            return (
              <Dropdown.Item
                key={label}
                active={isCurrent}
                disabled={isDisabled && !isCurrent}
                style={{ paddingLeft: "2rem", fontSize: "0.9rem" }}
                onClick={() => {
                  if (isDisabled && !isCurrent) return;
                  handleStatusUpdate(label);
                  setActionsOpen(false);
                  setShowStatusSubmenu(false);
                }}
              >
                <i className={`fa-solid ${icon} ${color} me-2`}></i>
                {label}
              </Dropdown.Item>
            );
          })}
          {appointment.status === "New Patient" && (
              <Dropdown.Item onClick={() => { openAddPatientInfo(); setActionsOpen(false); }}>
                <i className="fa-solid fa-user-plus me-2"></i> Add Patient Info
              </Dropdown.Item>
            )}
          {appointment.status !== "Scheduling" &&
            appointment.status !== "New Patient" &&
            appointment.status !== "Cancelled" &&
            !appointment.isInvoiced &&
            appointment.practiceId &&
            appointment.serviceId &&
            selectedResourceId && (
              <Dropdown.Item onClick={() => { handleNavToInvoice(); setActionsOpen(false); }}>
                <i className="fa-solid fa-file-invoice-dollar me-2"></i> Create Invoice
              </Dropdown.Item>
            )}
          {appointment.status !== "Scheduling" &&
            appointment.status !== "Cancelled" &&
            appointment.practiceId &&
            appointment.serviceId &&
            selectedResourceId && (
              <Dropdown.Item onClick={() => { handleNavToAppointment(); setActionsOpen(false); }}>
                <i className="fa-solid fa-pen-to-square me-2"></i> Go To Session
              </Dropdown.Item>
            )}
          <Dropdown.Divider />
          <Dropdown.Item onClick={(e) => { e.stopPropagation(); setShowDeleteSubmenu(!showDeleteSubmenu); }}>
            <i className="fa fa-trash me-2"></i> Delete
            <i className={`fa-solid fa-chevron-${showDeleteSubmenu ? "up" : "down"} ms-2`} style={{ fontSize: "0.7rem" }}></i>
          </Dropdown.Item>
          {showDeleteSubmenu && (
            <>
              <Dropdown.Item
                style={{ paddingLeft: "2rem", fontSize: "0.9rem" }}
                disabled={appointment.isNotesDone || appointment.isInvoiced || appointment.isInvoiceEmailed || appointment.isPaid}
                onClick={() => { setDeleteAlert(true); setActionsOpen(false); setShowDeleteSubmenu(false); }}
              >
                <i className="fa-solid fa-calendar-xmark me-2"></i> This appointment
              </Dropdown.Item>
              {appointment.isRecurring && appointment.recurringID && (
                <Dropdown.Item
                  style={{ paddingLeft: "2rem", fontSize: "0.9rem" }}
                  disabled={appointment.isNotesDone || appointment.isInvoiced || appointment.isInvoiceEmailed || appointment.isPaid}
                  onClick={() => { setDeleteSeriesAlert(true); setActionsOpen(false); setShowDeleteSubmenu(false); }}
                >
                  <i className="fa-solid fa-calendar-minus me-2"></i> This & future in series
                </Dropdown.Item>
              )}
            </>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </div>

  </div>
</Modal.Header>


        {closeAlert && (
          <Alert
            variant="info"
            className="w-100 d-flex align-items-center justify-content-between"
          >
            <span>
              Are you sure you want to close? The entered data will be removed.
            </span>
            <div className="d-flex">
              <Button
                variant="outline-primary"
                className="btn btn-outline-primary me-2"
                onClick={handleCancelYes}
              >
                <FaCheck />
              </Button>
              <Button
                variant="outline-secondary"
                className="btn btn-outline-secondary"
                onClick={handleCancelNo}
              >
                <FaTimes />
              </Button>
            </div>
          </Alert>
        )}
        {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
        {alertMessage && (
          <Alert variant="info" className="w-100">
            {alertText && (
              <div className="mb-0">
                <p className="mb-1 fw-bold text-primary">Please Note:</p>
                {Array.isArray(alertText) ? (
                  <ul className="mb-0 ps-3 text-primary">
                    {alertText.map((text, idx) => (
                      <li key={idx}>{text}</li>
                    ))}
                  </ul>
                ) : (
                  <strong>{alertText}</strong>
                )}
              </div>
            )}
          </Alert>
        )}

        {deleteAlert && (
          <Alert
            variant="danger"
            className="w-100 d-flex align-items-center justify-content-between"
          >
            <span>Are you sure you want to delete this appointment? This action cannot be undone.</span>
            <div className="d-flex">
              <Button
                variant="outline-danger"
                className="me-2"
                disabled={isDeleting}
                onClick={async () => {
                  setIsDeleting(true);
                  try {
                    await deleteAppointment(appointment.id);
                    const updatedAppointments = await getAppointmentsByPracticeIds(practiceIds);
                    const formattedEvents = updatedAppointments.map((evt) => ({
                      ...evt,
                      extendedProps: {
                        ...evt,
                        patientEmail: evt.patientEmail,
                        patientPhone: evt.patientPhone,
                      },
                    }));
                    setEvents(formattedEvents);
                    setDeleteAlert(false);
                    showToast("success", "Appointment deleted successfully.");
                    onHide();
                  } catch (error) {
                    console.error("Error deleting appointment:", error);
                    showToast("error", "Failed to delete appointment.");
                  } finally {
                    setIsDeleting(false);
                  }
                }}
              >
                {isDeleting ? (
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                ) : (
                  <FaCheck />
                )}
              </Button>
              <Button
                variant="outline-secondary"
                onClick={() => setDeleteAlert(false)}
              >
                <FaTimes />
              </Button>
            </div>
          </Alert>
        )}

        {deleteSeriesAlert && (
          <Alert
            variant="danger"
            className="w-100 d-flex align-items-center justify-content-between"
          >
            <span>Delete this and all future appointments in this series? Appointments with notes, invoices, or payments will be skipped.</span>
            <div className="d-flex">
              <Button
                variant="outline-danger"
                className="me-2"
                disabled={isDeleting}
                onClick={async () => {
                  setIsDeleting(true);
                  try {
                    const result = await deleteAppointmentSeries(appointment.recurringID, appointment.start);
                    const updatedAppointments = await getAppointmentsByPracticeIds(practiceIds);
                    const formattedEvents = updatedAppointments.map((evt) => ({
                      ...evt,
                      extendedProps: {
                        ...evt,
                        patientEmail: evt.patientEmail,
                        patientPhone: evt.patientPhone,
                      },
                    }));
                    setEvents(formattedEvents);
                    setDeleteSeriesAlert(false);
                    if (result.skippedCount > 0) {
                      showToast("warning", `Deleted ${result.deletedCount} appointment(s). ${result.skippedCount} skipped (have notes, invoices, or payments).`);
                    } else {
                      showToast("success", `Deleted ${result.deletedCount} appointment(s) from the series.`);
                    }
                    onHide();
                  } catch (error) {
                    console.error("Error deleting appointment series:", error);
                    showToast("error", "Failed to delete appointment series.");
                  } finally {
                    setIsDeleting(false);
                  }
                }}
              >
                {isDeleting ? (
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                ) : (
                  <FaCheck />
                )}
              </Button>
              <Button
                variant="outline-secondary"
                onClick={() => setDeleteSeriesAlert(false)}
              >
                <FaTimes />
              </Button>
            </div>
          </Alert>
        )}

        <Modal.Body style={{ position: 'relative', minHeight: '400px' }}>
  {isUpdatingStatus && (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
        borderRadius: '0.375rem'
      }}
    >
      <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="mt-3 fw-bold text-primary">Updating status...</p>
    </div>
  )}
  <Form>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>Title</Form.Label>
                  <Form.Control
                    type="text"
                    name="title"
                    value={appointment.title}
                    onChange={handleChangeAppointment}
                    readOnly={!isEditMode}
                    style={!isEditMode ? { backgroundColor: "#e9ecef", color: "#6c757d" } : {}}
                    isInvalid={!!errors.title}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.title}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Group>
                  <Form.Label>Start</Form.Label>
                  <Form.Control
                    type="datetime-local"
                    name="start"
                    value={appointment.start}
                    onChange={handleStartTimeChange}
                    readOnly={!isEditMode}
                    style={!isEditMode ? { backgroundColor: "#e9ecef", color: "#6c757d" } : {}}
                    isInvalid={!!errors.start}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.start}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>End</Form.Label>
                  <Form.Control
                    type="datetime-local"
                    name="end"
                    value={appointment.end}
                    onChange={
                      isEditMode && appointment.status === "Scheduling"
                        ? handleEndTimeChange
                        : undefined
                    }
                    readOnly={!isEditMode || appointment.status !== "Scheduling"}
                    style={!isEditMode ? { backgroundColor: "#e9ecef", color: "#6c757d" } : {}}
                    isInvalid={!!errors.end}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.end}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            {appointment.status !== "Scheduling" && (
              <div>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Label>Service</Form.Label>
                      <Form.Select
                        name="serviceId"
                        value={appointment.serviceId}
                        onChange={handleServiceChange}
                        disabled={!isEditMode}
                        style={!isEditMode ? { backgroundColor: "#e9ecef", color: "#6c757d" } : {}}
                      >
                        <option value="" disabled>
                          Select a Service
                        </option>
                        {services.map((service) => (
                          <option key={service._id} value={service._id}>
                            {service.servicesName}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            )}
            <Row className="mb-2 mt-3">
              <Form.Group as={Col} controlId="appointmentConfirmationEmail">
                <Form.Check
                  type="checkbox"
                  label="Send confirmation email"
                  name="appointmentConfirmationEmail"
                  checked={appointment.appointmentConfirmationEmail}
                  disabled={!isEditMode}
                  style={!isEditMode ? { color: "#6c757d" } : {}}
                  onChange={(e) => {
                    const { name, checked } = e.target;
                    handleChangeAppointment({
                      target: { name, value: checked },
                    });
                  }}
                />
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group controlId="appointmentNotes">
                <Form.Label>Notes</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="notes"
                  value={appointment.notes}
                  onChange={handleChangeAppointment}
                  readOnly={!isEditMode}
                  style={!isEditMode ? { backgroundColor: "#e9ecef", color: "#6c757d" } : {}}
                />
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Col>
                <Form.Group controlId="appointmentResource">
                  <Form.Label>Therapist</Form.Label>
                  <Form.Select
                    name="resourceId"
                    value={selectedResourceId}
                    disabled={!isEditMode}
                    style={!isEditMode ? { backgroundColor: "#e9ecef", color: "#6c757d" } : {}}
                    onChange={(e) => {
                      const newResourceId = e.target.value;
                      setSelectedResourceId(newResourceId);
                      const picked = resourceList.find(
                        (r) => toId(r) === newResourceId
                      );
                      setAppointment((prev) => ({
                        ...prev,
                        resourceId: newResourceId,
                        resourceName: picked
                          ? `${picked.firstName} ${picked.lastName}`
                          : prev.resourceName,
                      }));
                      hasCalculatedEndRef.current = false; // Allow recalculation
                    }}
                    isInvalid={!!errors.resourceId}
                  >
                    <option value="" disabled>
                      Select a Therapist
                    </option>
                    {filteredResources.length > 0 ? (
                      filteredResources.map((resource) => (
                        <option key={toId(resource)} value={toId(resource)}>
                          {resource.firstName} {resource.lastName}
                        </option>
                      ))
                    ) : (
                      <option disabled>No Available Therapists</option>
                    )}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.resourceId}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            {appointment.status !== "Scheduling" && (
              <>
              <Row className="mb-3">
                <Form.Group as={Col} md={6} controlId="appointmentPractice">
                  <Form.Label>Practice</Form.Label>
                  <Form.Select
                    name="practice"
                    value={appointment.practiceId}
                    disabled={!isEditMode}
                    style={!isEditMode ? { backgroundColor: "#e9ecef", color: "#6c757d" } : {}}
                    onChange={(e) => {
                      const practiceId = e.target.value;
                      const selectedPractice = practices.find(
                        (pr) => pr.practiceNumber === practiceId
                      );

                      setSelectedPracticeId(practiceId);
                      setAppointment((prev) => ({
                        ...prev,
                        practiceId: practiceId,
                        practiceName: selectedPractice
                          ? selectedPractice.practiceName
                          : "",
                      }));

                      const locs = buildFallbackLocations(
                        selectedPractice || {}
                      );
                      setLocationsForPractice(locs);
                      const idx = 0;
                      setSelectedLocationIdx(idx);

                      const first = locs[idx] || {};
                      setAppointment((prev) => ({
                        ...prev,
                        location: { ...first },
                        locationName:
                          first.name ||
                          selectedPractice?.primaryLocationName ||
                          "Main Location",
                        locationAddress: compactAddress(first),
                        locationIdx: idx,
                      }));
                    }}
                    isInvalid={!!errors.practiceId}
                  >
                    <option value="" disabled>
                      Select a Practice
                    </option>
                    {practices && practices.length > 0 ? (
                      practices.map((practice) => (
                        <option
                          key={practice.practiceNumber}
                          value={practice.practiceNumber}
                        >
                          {practice.practiceName}
                        </option>
                      ))
                    ) : (
                      <option disabled>No Practices Available</option>
                    )}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    {errors.practiceId}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} md={6} controlId="appointmentLocation">
                  <Form.Label>Location</Form.Label>
                  <Form.Select
                    name="locationIdx"
                    value={String(selectedLocationIdx)}
                    onChange={(e) => {
                      const idx = Number(e.target.value);
                      const loc = locationsForPractice[idx] || {};
                      setSelectedLocationIdx(idx);

                      setAppointment((prev) => ({
                        ...prev,
                        location: { ...loc },
                        locationName:
                          loc.name ||
                          practices.find(
                            (x) => x.practiceNumber === prev.practiceId
                          )?.primaryLocationName ||
                          "Location",
                        locationAddress: compactAddress(loc),
                        locationIdx: idx,
                      }));
                    }}
                    disabled={!isEditMode || locationsForPractice.length === 0}
                    style={!isEditMode ? { backgroundColor: "#e9ecef", color: "#6c757d" } : {}}
                  >
                    {locationsForPractice.length > 0 ? (
                      locationsForPractice.map((loc, idx) => (
                        <option key={`loc-${idx}`} value={String(idx)}>
                          {(loc.name || "Location") +
                            " — " +
                            [loc.address1, loc.city, loc.province]
                              .filter(Boolean)
                              .join(", ")}
                        </option>
                      ))
                    ) : (
                      <option value="0">No Location</option>
                    )}
                  </Form.Select>
                  {/* 🔧 Show warning if location doesn't match any in the list */}
                  {appointment.location &&
                    appointment.location.name &&
                    locationsForPractice.length > 0 &&
                    !locationsForPractice.some(
                      (l) =>
                        l.name === appointment.location.name &&
                        l.address1 === appointment.location.address1
                    ) && <div className="form-text text-warning"></div>}
                  {(!appointment.location || !appointment.location.name) && (
                    <div className="form-text">
                      Defaults to the first location (primary).
                    </div>
                  )}
                </Form.Group>
              </Row>

              {/* Intake form row */}
              <Row className="mb-3">
                <Col>
                  <Form.Label className="fw-semibold">Intake Form</Form.Label>
                  {intakeSession ? (
                    <div className="border rounded bg-white small mb-2">
                      {/* Intake link */}
                      {intakeSession.link && (
                        <div className="p-2 d-flex align-items-center gap-2 border-bottom">
                          <Form.Control
                            size="sm"
                            readOnly
                            value={intakeSession.link}
                            style={{ fontSize: "0.72rem", backgroundColor: "#e9ecef", color: "#6c757d" }}
                          />
                          <Button
                            size="sm"
                            variant="outline-secondary"
                            style={{ whiteSpace: "nowrap" }}
                            onClick={() => navigator.clipboard?.writeText(intakeSession.link)}
                          >
                            Copy
                          </Button>
                        </div>
                      )}

                      {/* History - expandable table */}
                      {intakeSession.auditLog?.length > 0 && (
                        <div className="p-2">
                          <Table bordered responsive size="sm" className="mb-0 align-middle">
                            <thead
                              className="table-primary"
                              style={{ cursor: "pointer", userSelect: "none" }}
                              onClick={() => setIntakeHistoryOpen((o) => !o)}
                            >
                              <tr>
                                <th className="text-primary fw-semibold" style={{ width: "45%" }}>
                                  {intakeHistoryOpen ? "▾" : "▸"} Date / Time
                                </th>
                                <th className="text-primary fw-semibold">
                                  History &nbsp;·&nbsp;
                                  <span className={
                                    intakeSession.status === "SUBMITTED" ? "text-success" :
                                    intakeSession.status === "EXPIRED" ? "text-danger" : "text-warning"
                                  }>
                                    {intakeSession.status}
                                  </span>
                                  {intakeSession.deliveryMethod && (
                                    <span className="text-muted fw-normal"> · {intakeSession.deliveryMethod.toUpperCase()}</span>
                                  )}
                                </th>
                              </tr>
                            </thead>
                            {intakeHistoryOpen && (
                              <tbody>
                                {[...intakeSession.auditLog].reverse().map((entry, i) => (
                                  <tr key={i}>
                                    <td className="text-muted text-nowrap">{new Date(entry.timestamp).toLocaleString()}</td>
                                    <td>
                                      {({
                                        CREATED: "Link created",
                                        OPENED: "Link opened by patient",
                                        SUBMIT_ATTEMPT: "Submission attempted",
                                        SUBMITTED: "Form submitted",
                                        LOCKED: "Session locked",
                                        EXPIRED: "Link expired",
                                      }[entry.action] || entry.action)}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            )}
                          </Table>
                        </div>
                      )}

                      {/* Server result - expandable table */}
                      {intakeSession.serverOutcome && (
                        <div className="px-2 pb-2">
                          <Table bordered responsive size="sm" className="mb-0 align-middle">
                            <thead
                              className="table-primary"
                              style={{ cursor: "pointer", userSelect: "none" }}
                              onClick={() => setIntakeOutcomeOpen((o) => !o)}
                            >
                              <tr>
                                <th className="text-primary fw-semibold" style={{ width: "45%" }}>
                                  {intakeOutcomeOpen ? "▾" : "▸"} Server Result
                                </th>
                                <th className={`fw-semibold ${({
                                  CREATED: "text-success",
                                  MATCHED: "text-success",
                                  REVIEW_REQUIRED: "text-warning",
                                  FAILED: "text-danger",
                                }[intakeSession.serverOutcome.resolution] || "text-primary")}`}>
                                  {{
                                    CREATED: "Patient & account created",
                                    MATCHED: "Matched to existing record",
                                    REVIEW_REQUIRED: "Sent to review queue",
                                    FAILED: "Processing failed",
                                  }[intakeSession.serverOutcome.resolution] || intakeSession.serverOutcome.resolution}
                                </th>
                              </tr>
                            </thead>
                            {intakeOutcomeOpen && (intakeSession.serverOutcome.reviewReason || intakeSession.serverOutcome.patientId || intakeSession.serverOutcome.accountId || intakeSession.serverOutcome.reviewId) && (
                              <tbody>
                                {intakeSession.serverOutcome.reviewReason && (
                                  <tr>
                                    <td className="text-muted">Reason</td>
                                    <td>
                                      {{
                                        FAMILYCHECK_FAILED: "Family Check could not be completed",
                                        FAMILYCHECK_NO_DEPENDANTS: "No dependants found on medical aid",
                                        DUPLICATE_PATIENT_ID: "Patient ID number already exists",
                                        DUPLICATE_MEDICAL_AID_NUMBER: "Medical aid number already registered",
                                        DUPLICATE_PATIENT_DOB_EMAIL: "Duplicate DOB and email match found",
                                        PATIENT_ALREADY_LINKED: "Patient already linked to this account",
                                        NO_PATIENT_MATCH: "Could not find matching patient record",
                                        MULTIPLE_PATIENT_MATCHES: "Multiple patient records found",
                                        NO_ACCOUNT_MATCH: "Could not find matching account",
                                        MULTIPLE_ACCOUNT_MATCHES: "Multiple accounts found",
                                        DUPLICATE_ACCOUNT_ID: "Account ID number already exists",
                                      }[intakeSession.serverOutcome.reviewReason] || intakeSession.serverOutcome.reviewReason}
                                    </td>
                                  </tr>
                                )}
                                {intakeSession.serverOutcome.patientId && (
                                  <tr><td className="text-muted">Patient ID</td><td>{String(intakeSession.serverOutcome.patientId)}</td></tr>
                                )}
                                {intakeSession.serverOutcome.accountId && (
                                  <tr><td className="text-muted">Account ID</td><td>{String(intakeSession.serverOutcome.accountId)}</td></tr>
                                )}
                                {intakeSession.serverOutcome.reviewId && (
                                  <tr><td className="text-muted">Review ID</td><td>{String(intakeSession.serverOutcome.reviewId)}</td></tr>
                                )}
                              </tbody>
                            )}
                          </Table>
                        </div>
                      )}

                      {/* Consent record - expandable */}
                      {intakeSession.submittedData?.consent && (
                        <div className="px-2 pb-2">
                          <Table bordered responsive size="sm" className="mb-0 align-middle">
                            <thead
                              className="table-primary"
                              style={{ cursor: "pointer", userSelect: "none" }}
                              onClick={() => setIntakeConsentOpen((o) => !o)}
                            >
                              <tr>
                                <th className="text-primary fw-semibold" style={{ width: "45%" }}>
                                  {intakeConsentOpen ? "▾" : "▸"} Consent Record
                                </th>
                                <th className={`fw-semibold ${intakeSession.submittedData.consent.agreed ? "text-success" : "text-danger"}`}>
                                  {intakeSession.submittedData.consent.agreed ? "✓ Consent given" : "✗ No consent"}
                                  {intakeSession.submittedData.consent.isProxy && (
                                    <span className="text-warning fw-normal"> · Proxy</span>
                                  )}
                                </th>
                              </tr>
                            </thead>
                            {intakeConsentOpen && (
                              <tbody>
                                <tr>
                                  <td className="text-muted">Consent Given</td>
                                  <td>
                                    {intakeSession.submittedData.consent.agreed
                                      ? <span className="text-success fw-semibold">✓ Yes</span>
                                      : <span className="text-danger fw-semibold">✗ No</span>}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="text-muted">Submitted by</td>
                                  <td>
                                    {intakeSession.submittedData.consent.isProxy
                                      ? <span className="text-warning fw-semibold">Proxy</span>
                                      : "Self"}
                                  </td>
                                </tr>
                                {intakeSession.submittedData.consent.isProxy && intakeSession.submittedData.consent.proxyNote && (
                                  <tr>
                                    <td className="text-muted">Proxy Note</td>
                                    <td>{intakeSession.submittedData.consent.proxyNote}</td>
                                  </tr>
                                )}
                                {intakeSession.clientMeta?.ipLastSeen && (
                                  <tr>
                                    <td className="text-muted">IP Address</td>
                                    <td className="font-monospace">{intakeSession.clientMeta.ipLastSeen}</td>
                                  </tr>
                                )}
                                {(intakeSession.submittedAt || intakeSession.auditLog?.find(e => e.action === "SUBMITTED")?.timestamp) && (
                                  <tr>
                                    <td className="text-muted">Submitted At</td>
                                    <td>
                                      {new Date(
                                        intakeSession.submittedAt ||
                                        intakeSession.auditLog.find(e => e.action === "SUBMITTED").timestamp
                                      ).toLocaleString()}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            )}
                          </Table>
                        </div>
                      )}

                      {/* Submitted form data tables */}
                      {intakeSession.submittedData && (
                        <div className="px-2 pb-2">
                          <Table bordered responsive size="sm" className="mb-0 align-middle">
                            <thead
                              className="table-primary"
                              style={{ cursor: "pointer", userSelect: "none" }}
                              onClick={() => setIntakeDataOpen((o) => !o)}
                            >
                              <tr>
                                <th className="text-primary fw-semibold" colSpan={2}>
                                  {intakeDataOpen ? "▾" : "▸"} Submitted Form Data
                                </th>
                              </tr>
                            </thead>
                          </Table>
                          {intakeDataOpen && [
                            intakeSession.submittedData.medicalAid && {
                              title: "Medical Aid",
                              rows: [
                                ["Scheme", intakeSession.submittedData.medicalAid.schemeName],
                                ["Plan", intakeSession.submittedData.medicalAid.planName],
                                ["Option", intakeSession.submittedData.medicalAid.optionName],
                                ["Number", intakeSession.submittedData.medicalAid.medicalAidNumber],
                                ["Dependant Code", intakeSession.submittedData.medicalAid.dependantCode],
                              ],
                            },
                            intakeSession.submittedData.patient && {
                              title: "Patient",
                              rows: [
                                ["Name", [intakeSession.submittedData.patient.firstName, intakeSession.submittedData.patient.lastName].filter(Boolean).join(" ")],
                                ["ID Number", intakeSession.submittedData.patient.idNumber],
                                ["Date of Birth", intakeSession.submittedData.patient.dob],
                                ["Gender", { "1": "Male", "2": "Female" }[intakeSession.submittedData.patient.gender] || intakeSession.submittedData.patient.gender],
                                ["Phone", intakeSession.submittedData.patient.tel],
                                ["Email", intakeSession.submittedData.patient.email],
                                ["Language", intakeSession.submittedData.patient.language],
                              ],
                            },
                            intakeSession.submittedData.accountHolder && {
                              title: "Account Holder",
                              rows: [
                                ["Name", [intakeSession.submittedData.accountHolder.firstName, intakeSession.submittedData.accountHolder.lastName].filter(Boolean).join(" ")],
                                ["ID Number", intakeSession.submittedData.accountHolder.idNumber],
                                ["Date of Birth", intakeSession.submittedData.accountHolder.dob],
                                ["Phone", intakeSession.submittedData.accountHolder.tel],
                                ["Email", intakeSession.submittedData.accountHolder.email],
                                ["Address", [intakeSession.submittedData.accountHolder.address1, intakeSession.submittedData.accountHolder.city, intakeSession.submittedData.accountHolder.province, intakeSession.submittedData.accountHolder.postalCode].filter(Boolean).join(", ")],
                              ],
                            },
                            intakeSession.submittedData.contact && {
                              title: "Contact",
                              rows: [
                                ["Phone", intakeSession.submittedData.contact.tel],
                                ["Email", intakeSession.submittedData.contact.email],
                                ["Language", intakeSession.submittedData.contact.language],
                                ["Address", [intakeSession.submittedData.contact.address1, intakeSession.submittedData.contact.city, intakeSession.submittedData.contact.province, intakeSession.submittedData.contact.postalCode].filter(Boolean).join(", ")],
                              ],
                            },
                          ].filter(Boolean).map(({ title, rows }) => (
                            <Table key={title} bordered responsive size="sm" className="mb-2 align-middle">
                              <thead className="table-primary">
                                <tr>
                                  <th className="text-primary fw-semibold" colSpan={2}>{title}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {rows.filter(([, v]) => v).map(([label, val]) => (
                                  <tr key={label}>
                                    <td className="text-muted" style={{ width: "40%" }}>{label}</td>
                                    <td>{val}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          ))}
                        </div>
                      )}
                    </div>
                  ) : (
                    <p className="text-muted small mb-2">No intake form has been sent for this appointment.</p>
                  )}
                  {intakeEnabled && appointment.status === "New Patient" && (!intakeSession || ["CREATED", "OPENED"].includes(intakeSession.status)) && (
                    <>
                      <Form.Check
                        type="checkbox"
                        label="Send Intake form via email"
                        className="mt-1"
                        checked={sendIntakeEmail}
                        disabled={!isEditMode || !appointment.patientEmail || intakeSending}
                        title={!appointment.patientEmail ? "Patient email required" : ""}
                        onChange={(e) => setSendIntakeEmail(e.target.checked)}
                      />
                      {intakeSending && (
                        <div className="text-muted small mt-1">
                          <span className="spinner-border spinner-border-sm me-1" />Sending intake link...
                        </div>
                      )}
                    </>
                  )}
                </Col>
              </Row>
              </>
            )}
          </Form>
        </Modal.Body>
        {isEditMode && (
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={handleSaveAppointment}
              className="text-white d-flex align-items-center justify-content-center gap-2"
              disabled={isLoading || isUpdatingStatus}
            >
              {isLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Saving...
                </>
              ) : (
                <>
                  <i className="fa-regular fa-floppy-disk"></i>
                  Submit
                </>
              )}
            </Button>
          </Modal.Footer>
        )}
      </Modal>

      {modalShow && (
        <AddPatientSteps
          show={modalShow}
          onHide={() => setModalShow(false)}
          patientFirstName={modalData?.patientFirstName}
          patientLastName={modalData?.patientLastName}
          patientEmail={modalData?.patientEmail}
          patientCellNumber={modalData?.patientPhone}
          appointmentId={modalData?.appointmentId}
          onSaved={() => {
            setModalShow(false);
            setRefreshTick((t) => t + 1);
          }}
        />
      )}

      <AppToast
        show={toast.show}
        onClose={hideToast}
        variant={toast.variant}
        message={toast.message}
      />
    </div>
  );
}
